document.addEventListener('DOMContentLoaded', () => {
  // Run animation once for on viewport
  handleScroll();

  // Add scroll event listener
  window.addEventListener('scroll', handleScroll);
});

// Function to check if an element is in viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
// Function to handle scroll event
function handleScroll() {
  // Trigger for on viewport element animation running
  const onViewportElements = document.querySelectorAll('.animate__viewport');

  onViewportElements.forEach((element) => {
    isInViewport(element)
      ? element.classList.add('animate__onViewport')
      : element.classList.remove('animate__onViewport');
  });
}
